// 지금이 몇 일차 낮/밤인지를 화면 읽기(readClock 결과)로부터 안정적으로 정한다 (순수 함수).
// - 같은 값이 두 번 연속 읽혀야 바꾼다(낮↔밤 전환 순간 아이콘이 잠깐 틀리게 읽히는 것 등으로 깜빡이지 않게).
// - 일차 숫자를 못 읽으면(샘플이 없는 8일차 등) 직전 확정 값에서 이어서 센다: 낮→밤은 같은 일차, 밤→낮은 다음 일차.
// - 일차는 거꾸로 가지 않는다: 읽은 숫자가 이어서 센 값보다 작으면 오인식으로 보고 이어서 센 값을 쓴다.

const CONFIRM_COUNT = 2;

export function createPhaseTracker() {
  let confirmed = null; // { day: number | null, phase: 'day' | 'night' }
  let candidate = null; // { key, value, count }

  const keyOf = (value) => `${value.day}|${value.phase}`;

  // 일차를 못 읽었을 때 직전 확정 값으로 추정한다. 직전 값도 일차를 모르면 null.
  const inferDay = (phase) => {
    if (!confirmed || confirmed.day === null) {
      return null;
    }
    return confirmed.phase === 'night' && phase === 'day' ? confirmed.day + 1 : confirmed.day;
  };

  return {
    update(reading) {
      if (!reading) {
        return confirmed;
      }
      // 읽은 일차 숫자가 이어서 센 값보다 작으면 오인식(샘플이 없는 숫자가 다른 숫자로 읽힌 경우 등)으로 보고 이어서 센 값을 쓴다.
      // 더 크면(전환을 놓친 경우) 읽은 숫자를 따른다.
      const inferred = inferDay(reading.phase);
      const readDay = reading.day !== null && reading.day !== undefined ? reading.day : null;
      const day = readDay === null || (inferred !== null && readDay < inferred) ? inferred : readDay;
      const value = { day, phase: reading.phase };
      const key = keyOf(value);
      if (confirmed && keyOf(confirmed) === key) {
        candidate = null;
        return confirmed;
      }
      candidate = candidate && candidate.key === key ? { ...candidate, count: candidate.count + 1 } : { key, value, count: 1 };
      if (candidate.count >= CONFIRM_COUNT) {
        confirmed = candidate.value;
        candidate = null;
      }
      return confirmed;
    },
    current: () => confirmed,
    reset() {
      confirmed = null;
      candidate = null;
    },
  };
}

// 화면에 보여줄 글자. 알 수 없으면 null, 일차를 모르면 낮/밤만.
export function formatPhase(current) {
  if (!current) {
    return null;
  }
  const phase = current.phase === 'night' ? '밤' : '낮';
  return current.day === null || current.day === undefined ? phase : `${current.day}일차 ${phase}`;
}
